// Comprobante del cobro: factura electrónica o ticket —
// SPEC_VENTAS_INNOMINADAS_FACTURACION_DIFERIDA_v0.1.md RN-VI1 y RN-VI2 (en
// pos-graciela-api/docs). Espejo de `esDocumentoInnominado`
// (pos-graciela-api/src/domain/fiscal/receptor.js): el API valida igual y
// rechaza un ticket que no corresponde.

export const COMPROBANTES = Object.freeze({ FACTURA: 'FACTURA', TICKET: 'TICKET' })

// Vacío, sin dígitos ("S/D") o sólo ceros ("0", "000").
export const esDocumentoInnominado = (documento) => {
  const texto = String(documento ?? '').trim()
  if (!/\d/.test(texto)) return true
  return !/[1-9]/.test(texto)
}

export const puedeElegirTicket = ({ documento, habilitado }) =>
  habilitado === true && esDocumentoInnominado(documento)

// RN-VI2 (revisada el 2026-10-12): con la operativa activa, innominado → TICKET
// por defecto; con documento → FACTURA. Sin la operativa, siempre FACTURA.
// Espejo de `comprobantePorDefecto` (pos-graciela-api/src/domain/fiscal/facturaExterna.js).
export const comprobantePorDefecto = ({ documento, habilitado }) =>
  (puedeElegirTicket({ documento, habilitado }) ? COMPROBANTES.TICKET : COMPROBANTES.FACTURA)
